__turbopack_context__.v({
  "activeLabel": "NiWWPa_activeLabel",
  "badge": "NiWWPa_badge",
  "grid": "NiWWPa_grid",
  "swatchButton": "NiWWPa_swatchButton",
});
